<template>
    <div>
      <b-row>
          <b-col lg="12">
              <div v-if="loading">
              <loader></loader>
              </div>
              <b-button block v-b-toggle.collapse-locations
                      class="font-weight-bold p-1 border"
                      variant="light"
              >

                  <h5 class="bg-light my-1 text-center font-weight-bold">
                      <i class="float-left fa fa-caret-square-o-down"/>
                      <i class="fa fa-map-marker"/>
                      UBICACIONES
                  </h5>
              </b-button>
          </b-col>
          <b-col lg="12">
              <b-collapse id="collapse-locations" class="mt-2">
              <b-card>
                  <center>
                  <b-form-group label="Filtrar" horizontal>
                      <b-form-input v-model="filterText" />
                  </b-form-group>
                  </center>
                  <el-tree
                  class="el-tree-company"
                  v-if="ubicaciones.length > 0"
                  :data="ubicaciones"
                  show-checkbox
                  node-key="id"
                  ref="tree"
                  highlight-current
                  :props="defaultProps"
                  :default-checked-keys="selecionadosIds"
                  :filter-node-method="filterNode"
                  check-strictly
                  >
                  </el-tree>
              </b-card>
              </b-collapse>
          </b-col>
      </b-row>
    </div>
  </template>

  <script>
  import { mapState, mapActions, mapMutations } from "vuex";
  import { getAcls } from "../../../plugins/acl";
  import loader from './../../../containers/loader';

  export default {
    name: "BasesAreasEmpresa",
    data: function () {
      return {
        filterText: "",
        loading: false,
        defaultProps: {
          label: 'label',
          children: 'children',
          disabled: (data) => {
            return true
          }
        },
        datos: {},
        acls: "",
        selecionadosIds: [],
        selecUbicaciones: [],
        initialSelection: [],
      };
    },
    async created() {
      this.acls = getAcls();
      await this.getUbicaciones();
    },
    computed: {
      ...mapState("productos_emp", [
        "ubicaciones",
        "seleccionado",
        "marcados",
        "ubicacionesContratista",
      ]),
    },
    components: {
      loader
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      },
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      },
      async getUbicaciones() {
          this.datos.producto = this.$route.params.id;
          this.datos.empresa = this.acls.empresa;
          this.datos.esEmpresa = 1;

          this.loading = true;
          await this.getUbicacionEmpresa(this.datos);
          this.setChecked(this.ubicaciones);
          await this.getUbicacionEmpresa(this.datos);
          this.loading = false;
        this.selecionadosIds = [];
        this.pusherSeleccionados(this.ubicaciones);
      },
      pusherSeleccionados(data) {
        let ubicaciones = data;
        ubicaciones.forEach((element) => {
          if (element.hasOwnProperty("get_product")) {
            if (element.get_product.length > 0) {
              element.get_product.forEach((el) => {
                if (el.id_producto == this.datos.producto) {
                  this.selecionadosIds.push(element.id);
                }
              });
            }
          }
          if (element.children.length) {
            this.pusherSeleccionados(element.children);
          }
        });
        this.initialSelection = [...new Set(this.selecionadosIds)];
      },

      async setChecked(ubicacion) {
        ubicacion.map((i) => {
          if (i.checked) {
            this.seleccionados(i.id);
          }
          this.setChecked(i.children);
        });
      },
      ...mapActions("productos_emp", ["getBasesAreasEmpresa", "getUbicacionEmpresa"]),
      ...mapMutations("productos_emp", [
        "seleccionados",
        "setSeleccionados",
        "setSeleccionados",
      ]),
    },
  };
  </script>

  <style>

  .el-tree-company .el-checkbox.is-disabled.is-checked .el-checkbox__inner {
    background-color: #097b83;
    border-color: #097b83;
  }


  </style>

  <style scoped>
  .checkbox-contratista .el-checkbox__inner {
    background-color: #5eb7bd !important;
    border-color: #5eb7bd !important;
    color: #fff;
  }

  @media screen and (max-width: 400px){
  span.custom-tree-node span{
    font-size: .55rem;
  }
  }
  </style>
